import { GetListRequest } from '@rest/ViewSetHttpService';
import { stableStringify } from '@query/utils/angular-query.utils';

export const serviceSettingsKeys = {
  all: ['serviceSettings'] as const,

  lists: () => [...serviceSettingsKeys.all, 'list'] as const,
  list: (params: GetListRequest = {}) =>
    [...serviceSettingsKeys.lists(), stableStringify(params)] as const,

  details: () => [...serviceSettingsKeys.all, 'detail'] as const,
  detailById: (uuid: string) => [...serviceSettingsKeys.details(), uuid] as const,
  detail: (uuid: string, params: Record<string, unknown> = {}) =>
    [...serviceSettingsKeys.detailById(uuid), 'params', stableStringify(params)] as const,

  sendTestEmail: () => [...serviceSettingsKeys.all, 'sendTestEmail'] as const,
  updateUISettings: () => [...serviceSettingsKeys.all, 'updateUISettings'] as const,

  invalidateAll: () => [...serviceSettingsKeys.all] as const,
  invalidateLists: () => [...serviceSettingsKeys.lists()] as const,
  invalidateSettings: (uuid: string) => [...serviceSettingsKeys.detailById(uuid)] as const,
};
